// Translation: Hub > Landing > Services (Turkish)
export default Object.freeze({
	fallback: {
		title: 'Hesap bilgisine şu an erişilemiyor'
	}
})
